import PropTypes from 'prop-types'
import React, { Component } from 'react'
import IconSVG from 'svg-inline-react'
import { makeDefaultFailedContainer } from 'components/container'
import InstallSnippetCard from 'components/InstallSnippetCard'
import style from './style.styl'

import fileCodeIconSrc from '!svg-inline?removeTags=true!images/icons/file-code-icon.svg'

const Step = ({ icon, className, children }) => (
  <div className={style.StepContainer}>
    <div className={className}>
      {icon}
    </div>
    <div className={style.StepContent}>
      {children}
    </div>
  </div>
)

class JavaScriptInstaller extends Component {
  static contextTypes = {
    app: PropTypes.object.isRequired,
  }

  static propTypes = {
    defaultEmbed: PropTypes.object.isRequired
  }

  getSnippet() {
    const { defaultEmbed: { snippet }} = this.props
    return `<!-- Start of Async Drift Code -->\n${ snippet.trim() }\n<!-- End of Async Drift Code -->`
  }

  render() {
    return (
      <div className={style.InstallSnippetContent}>
        <Step className={style.FileIcon} icon={<IconSVG src={fileCodeIconSrc}/>}>
          {'1. Paste the code below before the </head> tag on every page you want Drift to appear.'}
          <br/> <br/>
          {'Need some help? Click '}
          <a className={style.Link} href="https://help.drift.com/article/install-drift-on-your-website-javascript/">here</a>
          {' for more details!'}
          <InstallSnippetCard snippet={this.getSnippet()} />
        </Step>
      </div>
    )
  }
}

const JavaScriptInstallerContainer = makeDefaultFailedContainer(JavaScriptInstaller, {
  listenTo: ['stores.DefaultEmbedStore'],
  fetch: {
    defaultEmbed() {
      return this.app.stores.DefaultEmbedStore.getOrFetchCurrentDefaultEmbed()
    }
  }
})

export default JavaScriptInstallerContainer



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/JavaScriptInstaller.js